var map = {
	"./clickfunnels.png": 39670,
	"./drupal.png": 47529,
	"./gtm.png": 37837,
	"./magento.png": 46366,
	"./prestashop.png": 87093,
	"./shopify.png": 88559,
	"./squarespace.png": 77320,
	"./wix.png": 2985,
	"./woocommerce.png": 42518,
	"./wordpress.png": 29041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65803;